module.exports = __webpack_public_path__ + "img/制御工学5_8_3.48c5ffa8.png";